// lang/en.js
export default {
  copySuccess: "การจําลองแบบสําเร็จ",
  copyFail: "Copy fails, please try to copy manually",
  foot: {
    termsOfService: "นโยบายสมาชิก",
    privacyPolicy: "นโยบายความเป็นส่วนตัว",
    Notice: "ข้อสังเกต",
    EmailText: "อีเมลGM：",
    info: "© NEXON Korea Corp.All Rights Reserved",
    info1: "",
    info2: "",
    info3: "",
    info4: "",
    rotwilightsea:
      "© Gravity Co., LTD & Lee MyoungJin(studio DTDS). All Rights Reserved.",
  },
  notFound: {
    title: "หน้าที่คุณพยายามเข้าถึงไม่พบ...",
    content: "จะออกจากหน้านี้ในไม่ช้า, กลับสู่หน้าหลักโดยอัตโนมัติใน ",
    content2: " วินาที",
    btn: "กลับสู่หน้าหลัก",
  },
};
